import React from "react";
import { Col, Row, Modal, ModalBody, ModalHeader } from "reactstrap";
import { Badge, Card, Tag, Spin } from "antd"; // Importer Spin de Ant Design
import CardImageItem from "../../Users/component/CardImage";
import { useQuery } from "react-query";
import { getUserById } from "../../Users/services/userApi";
import { getVehicleHistory } from "../services/vehiculeApi";
import { ReloadOutlined } from "@ant-design/icons";

const HistoryVehicle = ({ modal, setModal, toggle, selectedVehicule, selectedVehHistory }) => {
  const { 
    brand, model, color, statut, transmission, speed, registrationNumber, 
    commissioningDate, vin, mileage, actualUserId, fileName, description
  } = selectedVehicule || {};
  const history = selectedVehHistory || [];

  const { isLoading: isLoadingDrivers, isError: isErrorDrivers, error, data: driver } = useQuery(
    ["driver", actualUserId], () => getUserById(actualUserId),
    { enabled: !!actualUserId }
  );

  return (
    <Modal isOpen={modal} toggle={toggle} centered backdrop="static" style={{ maxWidth: "1000px" }}>
      <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
        <span>Historiques du véhicule <Tag color="cyan"> {brand} </Tag> du modèle <Tag color="blue"> {model}</Tag></span>
      </ModalHeader>

      <ModalBody style={{ padding: "2rem 3rem", backgroundColor: "#f7f7f7" }}>
        <Card className="card-animate">
          <Row>
            <Col lg={8}>
              <Badge.Ribbon text="Image véhicule" color="cyan">
                <div style={{ width: '100%', overflow: 'hidden', margin: '0 auto', height: '50%' }}>
                  <CardImageItem fileName={fileName} />
                </div>
              </Badge.Ribbon>
            </Col>
            <Col lg={4}>
              <Badge.Ribbon text={brand} color="blue">
                <br/>
                <Card title="Information véhicule">
                  <div className="text-left mb-4">
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr><td style={{ fontWeight: "600" }}>Plaque</td><td>{registrationNumber || "-"}</td></tr>
                        <tr><td style={{ fontWeight: "600" }}>Marque</td><td>{brand || "-"}</td></tr>
                        <tr><td style={{ fontWeight: "600" }}>Modèle</td><td>{model || "-"}</td></tr>
                        <tr><td style={{ fontWeight: "600" }}>Couleur</td><td>{color || "-"}</td></tr>
                        <tr><td style={{ fontWeight: "600" }}>Statut</td><td>{statut || "-"}</td></tr>
                        <tr><td style={{ fontWeight: "600" }}>Transmission</td><td>{transmission || "-"}</td></tr>
                        <tr><td style={{ fontWeight: "600" }}>Vitesse</td><td>{speed ? `${speed} Km` : "-"}</td></tr>
                        <tr><td style={{ fontWeight: "600" }}>En service</td><td>{commissioningDate || "-"}</td></tr>
                        <tr><td style={{ fontWeight: "600" }}>VIN</td><td>{vin || "-"}</td></tr>
                        <tr><td style={{ fontWeight: "600" }}>Kilométrage</td><td>{mileage || "-"}</td></tr>
                        <tr><td style={{ fontWeight: "600" }}>Chauffeur</td><td>{driver?.name || "-"}</td></tr>
                      </tbody>
                    </table>
                  </div>
                </Card>
              </Badge.Ribbon>
            </Col>
          </Row>
        </Card>

        <Badge.Ribbon text={`Model ${model}`} color="cyan">
          <Card className="mb-4" title="Détail du véhicule" style={{ borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", backgroundColor: "#fff" }}>
            <Row>
              <Col lg={12}>
                <div>
                  <strong>Description : </strong> {description || '-'}
                </div>
              </Col>
            </Row>
          </Card>
        </Badge.Ribbon>

        <Badge.Ribbon text={`${history.length || 0} chauffeurs`} color="cyan">
            <Card className="mb-4" title={`Historiques des anciens chauffeurs`} style={{ borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", backgroundColor: "#fff" }}>
                {
                    history.length > 0 ? (
                        history.map((driverHistory, index) => (
                        <Row key={index}>
                            <Col lg={4}><strong>Nom : </strong> {driverHistory.name || "-"}</Col>
                            <Col lg={4}><strong>Email : </strong> {driverHistory.email || "-"}</Col>
                            <Col lg={4}><strong>Téléphone : </strong> {driverHistory.phone || "-"}</Col>
                            <Col lg={4}><strong>Adresse : </strong> {driverHistory.address || "-"}</Col>
                            <Col lg={4}><strong>Numéro CNI : </strong> {driverHistory.cniNumber || "-"}</Col>
                            <Col lg={4}><strong>Permis : </strong> {driverHistory.licenseNumber || "-"}</Col>
                            {index < history.length - 1 && <hr style={{ border: '0', borderTop: '2px solid #00bcd4', margin: '20px 0', opacity: 0.5, borderRadius: '5px' }}/>}
                        </Row>
                        ))
                    ) : (
                        <div className="text-center">Pas d'anciens chauffeurs pour ce véhicule {brand}</div>
                    )
                }
            </Card>
        </Badge.Ribbon>

      </ModalBody>
    </Modal>
  );
};

export default HistoryVehicle;
